<template>
  <input class="movelist-checkbox" type="checkbox" 
    @change="onCheckboxChange(repertoireId,params)"
    v-model="checkboxState"
  >
</template>

<script setup>

// https://stackoverflow.com/questions/76127817/pass-parent-component-in-ag-grid-context-with-vue3-composition-api


import { ref , computed } from "vue";

const props = defineProps({
  params : {
       type : Object,
       default : {}
   }
 })

 //console.log("***** DRILL ",props.params)
 const repertoireId = ref(props.params.data.id)
 const fieldName = props.params.colDef.field
 const checkboxState = ref(true)
 checkboxState.value = props.params.data[fieldName] == '1'

function onCheckboxChange(repertoireId,params) {
  //console.log("***** on checkbox change", repertoireId,checkboxState.value)
  params.context.parentFunction(params,params.colDef.field,repertoireId,checkboxState.value)
  //emit("checkbox-click",repertoireId,fieldName,checkboxState.value)
}

// to access function of parent component
const fun = (params) => {
  
}


</script>

<style scoped>

</style>